import { render, staticRenderFns } from "./GuestInfoPrivacy.vue?vue&type=template&id=773c567d&scoped=true"
import script from "./GuestInfoPrivacy.vue?vue&type=script&lang=js"
export * from "./GuestInfoPrivacy.vue?vue&type=script&lang=js"
import style0 from "./GuestInfoPrivacy.vue?vue&type=style&index=0&id=773c567d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773c567d",
  null
  
)

export default component.exports